import { render, staticRenderFns } from "./ReviewsBar.vue?vue&type=template&id=71e6b398&scoped=true&"
import script from "./ReviewsBar.vue?vue&type=script&lang=js&"
export * from "./ReviewsBar.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsBar.vue?vue&type=style&index=0&id=71e6b398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e6b398",
  null
  
)

export default component.exports